<template>
  <div>
    <el-card>
      <!-- 快捷入口 -->
      <el-card v-if="shortEntrance">
        <template #header>
          <div class="card-header">
            <span>常用功能</span>
          </div>
        </template>
        <el-row :gutter="20" style="margin: 20px">
          <template v-for="column in shortEntranceList" :key="column.id">
            <el-col :span="3" @click.prevent="shortLink(column.url)">
              <div class="sc-icon">
                <el-icon class="no-select"
                  ><el-image
                    :src="require('../assets/icon/' + column.icon + '.svg')"
                  ></el-image
                ></el-icon>
              </div>
              <div class="no-select">{{ column.name }}</div>
            </el-col>
          </template>
        </el-row>
      </el-card>

      <el-row :gutter="20">
        <el-col :span="12" v-if="evaEventsFlag">
          <!-- all: 待办事项时间提醒，快捷入口 -->
          <el-card
            class="card"
            :body-style="{ height: '100%' }"
            style="height: 200px"
          >
            <template #header>
              <div class="card-header">
                <span>待办事项</span>
              </div>
            </template>
            <ul>
              <li v-for="event in eventsList" :key="event.id">
                <div class="event">
                  <el-link :underline="false" :href="event.url">{{
                    event.name
                  }}</el-link>
                  <div></div>
                </div>
              </li>
            </ul>
          </el-card>
        </el-col>

        <el-col :span="12" v-if="personalScoreDetail">
          <!-- 科长、科员: 个人考评情况，各项得分 -->
          <el-card
            class="card personal-score-detail"
            :body-style="{ height: '100%' }"
          >
            <template #header>
              <div class="card-header">
                <span>个人考评得分</span>
              </div>
            </template>
            <NightingaleChart v-bind:chartData="chartData"></NightingaleChart>
            <!-- <div class="">
              <p>综合得分</p>
              <p
                style="
                  color: green;
                  font-size: 30px;
                  font-weight: bold;
                  margin: 0px;
                "
              >
                {{ totalScore }}
              </p>
            </div>
            <div style="display: flex; justify-content: space-between">
              <div>
                <p>共性指标得分</p>
                <p>100</p>
              </div>
              <div>
                <p>个性指标得分</p>
                <p>100</p>
              </div>
              <div>
                <p>关键指标得分</p>
                <p>100</p>
              </div>
            </div> -->
          </el-card>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12" v-if="personTaskMinitor">
          <!-- 科长、科员：个人工作（个性指标）完成情况 -->
          <el-card class="card">
            <template #header>
              <div class="card-header">
                <span>个性指标完成情况</span>
              </div>
            </template>
            <el-table
              :data="personalTaskList"
              stripe
              style="width: 100%"
              max-height="200"
              :default-sort="{
                prop: 'accomplishRate',
                order: 'descending',
              }"
            >
              <el-table-column label="排名" type="index" width="55" fixed />
              <template
                v-for="column in personalTaskTable"
                :key="column.userId"
              >
                <el-table-column :prop="column.prop" :label="column.label">
                </el-table-column>
              </template>
            </el-table>
          </el-card>
        </el-col>

        <el-col :span="12" v-if="employeeScoreDetail">
          <!-- 科长：科员考核综合得分 -->
          <el-card class="card"
            ><template #header>
              <div class="card-header">
                <span>考评得分情况</span>
              </div>
            </template>
            <el-table
              :data="employeeScoreList"
              stripe
              style="width: 100%"
              max-height="200"
              :default-sort="{
                prop: 'totalScore',
                order: 'descending',
              }"
            >
              <el-table-column label="排名" type="index" width="55" fixed />
              <template
                v-for="column in employeeScoreTable"
                :key="column.userId"
              >
                <el-table-column :prop="column.prop" :label="column.label">
                </el-table-column>
              </template> </el-table
          ></el-card>
        </el-col>

        <el-col :span="12" v-if="deptTaskMinitor">
          <!-- 分管领导、绩效、局长、局级管理、党组：科室个性指标完成情况 -->
          <el-card class="card">
            <template #header>
              <div class="card-header">
                <span>科室指标完成情况</span>
              </div>
            </template>
            <el-table
              :data="deptTaskList"
              stripe
              style="width: 100%"
              max-height="200"
              :default-sort="{
                prop: 'accomplishRate',
                order: 'descending',
              }"
            >
              <el-table-column label="排名" type="index" width="55" fixed />
              <template
                v-for="column in deptTaskTable"
                :key="column.departmentId"
              >
                <el-table-column :prop="column.prop" :label="column.label">
                </el-table-column>
              </template>
            </el-table>
          </el-card>
        </el-col>

        <el-col :span="12" v-if="deptScoreDetail">
          <!-- 分管领导、绩效、局长、局级管理、党组：科室综合均分 -->
          <el-card class="card"
            ><template #header>
              <div class="card-header">
                <span>科室考评得分情况</span>
              </div>
            </template>
            <el-table
              :data="deptScoreList"
              stripe
              style="width: 100%"
              max-height="200"
              :default-sort="{
                prop: 'totalScore',
                order: 'descending',
              }"
            >
              <el-table-column label="排名" type="index" width="55" fixed />
              <template
                v-for="column in deptScoreTable"
                :key="column.departmentId"
              >
                <el-table-column :prop="column.prop" :label="column.label">
                </el-table-column>
              </template> </el-table
          ></el-card>
        </el-col>

        <el-col :span="12" v-if="empCommonEvaStatus">
          <!-- 科长：共性指标哪些人没评价 -->
          <el-card class="card"
            ><template #header>
              <div class="card-header">
                <span>共性指标评价进度</span>
              </div>
            </template>
            <el-table
              :data="commonEvaEmployeeList"
              stripe
              style="width: 100%"
              max-height="200"
              :default-sort="{
                prop: 'userId',
                order: 'descending',
              }"
            >
              <el-table-column label="序号" type="index" width="55" fixed />
              <template
                v-for="column in commonEvaEmployeeTable"
                :key="column.userId"
              >
                <el-table-column
                  :prop="column.prop"
                  :label="column.label"
                  :sortable="column.sortable"
                  :formatter="formatter2"
                >
                </el-table-column>
              </template> </el-table
          ></el-card>
        </el-col>

        <el-col :span="12" v-if="deptCommonEvaStatus">
          <!-- 局级管理：科室共性指标评价情况 -->
          <el-card class="card"
            ><template #header>
              <div class="card-header">
                <span>科室共性指标评价情况</span>
              </div>
            </template>
            <el-table
              :data="commonEvaDeptList"
              stripe
              style="width: 100%"
              max-height="200"
              :default-sort="{
                prop: 'departmentId',
                order: 'descending',
              }"
            >
              <el-table-column label="序号" type="index" width="55" fixed />
              <template
                v-for="column in commonEvaDeptTable"
                :key="column.departmentId"
              >
                <el-table-column
                  :prop="column.prop"
                  :label="column.label"
                  :formatter="formatter"
                  :sortable="column.sortable"
                >
                </el-table-column>
              </template> </el-table
          ></el-card>
        </el-col>

        <el-col :span="12" v-if="WeekSummaryStatus">
          <!-- 科长、分管领导：科室成员小结填写情况 -->
          <el-card class="card"
            ><template #header>
              <div class="card-header">
                <span>科室成员小结填写情况</span>
              </div>
            </template>
            <el-table
              :data="weekSummaryList"
              stripe
              style="width: 100%"
              max-height="200"
              :default-sort="{
                prop: 'departmentId',
                order: 'descending',
              }"
              @cell-click="searchSummaryDetail"
            >
              <el-table-column label="序号" type="index" width="55" fixed />
              <template v-for="column in weekSummaryTable" :key="column.userId">
                <el-table-column
                  :prop="column.prop"
                  :label="column.label"
                  :sortable="column.sortable"
                >
                </el-table-column>
              </template>
            </el-table>
          </el-card>
        </el-col>

        <el-col :span="12" v-if="rootRole">
          <!-- root：系统信息设置 -->
          <el-card class="card"
            ><template #header>
              <div class="card-header">
                <span>系统信息设置</span>
              </div>
            </template>
            <el-form :model="loginForm" :rules="rules">
              <el-form-item label="开发者">
                <el-input v-model="sysParam.company"> </el-input>
              </el-form-item>
              <el-form-item label="联系电话">
                <el-input v-model="sysParam.numberPhone"> </el-input>
              </el-form-item>
              <el-form-item label="联系QQ">
                <el-input v-model="sysParam.numberQQ"> </el-input>
              </el-form-item>
              <el-button class="submit-btn" type="primary" @click="saveSysParam"
                >保存</el-button
              >
            </el-form>
          </el-card>
        </el-col>
      </el-row>
    </el-card>
    <el-dialog v-model="showable.summary" title="小结填写情况" width="60%">
      <el-timeline class="time-line">
        <el-timeline-item
          placement="top"
          v-for="(activity, index) in weekSummaryDetailList"
          :key="index"
          :timestamp="activity.timestamp"
        >
          <el-card class="sum-card">
            <el-input
              :rows="3"
              type="textarea"
              v-model="activity.summary"
            ></el-input>
          </el-card>
        </el-timeline-item>
      </el-timeline>
    </el-dialog>
  </div>
</template>

<script>
import Index from "../api/Index";
export default Index;
</script>

<style scoped lang="scss">
.card-header {
  size: 20px;
  text-align: left;
}

.single-card {
  height: 100%;
  width: 100%;
  border-radius: 15px;
  position: relative;
  .sc-txt {
    user-select: none;
    position: absolute;
    top: 30%;
    left: 10%;
    // right: 10%;
    // bottom: 0;
    // right: 0;
    justify-content: center;
    z-index: 2;
    font-size: 20px;
    color: white;
    // margin: auto;
  }
  .sc-icon {
    filter: blur(1px);
    right: 1%;
    bottom: 1%;
    user-select: none;
    position: absolute;
    z-index: 2;
    color: rgb(117, 117, 117);
  }
}

.single-col {
  margin-top: 20px;
  user-select: none;
}

.image {
  height: 100%;
  width: 100%;
  pointer-events: none;
  user-select: none;
  // opacity: 0.5;
  filter: blur(8px);
}

.card {
  margin-top: 20px;
}

.event {
  display: flex;
  justify-content: space-between;
}

.el-card {
  --el-card-padding: 15px;
  color: rgb(111, 108, 108);
}

.p {
  margin: 0;
}

.personal-score-detail {
  width: 100%;
  height: 200px;
}

.sc-icon {
  font-size: 60px;
  pointer-events: none;
}

.no-select {
  user-select: none;
}

// .sc-txt {
//   user-select: none;
//   position: absolute;
//   // top: 50%;
//   // left: 50%;
//   // transform: translate(-50%, -50%);
//   z-index: 2;
//   width: 100%;
//   justify-content: center;
//   align-items: center;
//   color: white;
//   margin: 0;
//   font-weight: 500;
//   font-size: 26px;
// }

// .threesolid {
//   color: #fefefe;
//   text-shadow: 0 0 0.5em #484948, 0 0 0.2em #4e2e2e;
// }
</style>